import dropdownMenuModule from 'react-accessible-dropdown-menu-hook/dist/use-dropdown-menu.js';

export default dropdownMenuModule.default || dropdownMenuModule;
